import { useDispatch, useSelector } from "react-redux";
import noRecharge from "../../../../assets/no-recharge.svg";
import "../../../../styles/screens/client-visit-details/manage-module/HotelList.css";
import { useEffect } from "react";
import Loader from "../../../common-components/Loader";
import {
  getAllHotelList,
  resetErrorAlert,
  updateHotelOrder,
} from "../../../../slices/HotelSlice";
import HotelListTableBody from "./HotelListTableBody";
import { RechargeStringLabels } from "../../../../util/Strings";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import ReorderModal from "../../../common-components/ReorderModal";

function HotelListTable({ showOrderModal, setShowOrderModal }) {
  const data = useSelector((state) => state.hotel.hotelList);
  const isLoading = useSelector((state) => state.hotel.isLoading);
  const isVisitCompleted = useSelector(
    (state) => state.visits.selectedVisitIsCompleted
  );
  const id = useSelector((state) => state.visits.selectedVisitId);
  const selectedOfficeId = useSelector(
    (state) => state.officelist.selectedOfficeId
  );
  const dispatch = useDispatch();
  const errorMessageCode = useSelector((state) => state.hotel.errorCode);

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  function getHotelDetails() {
    dispatch(getAllHotelList(selectedOfficeId));
  }

  useEffect(() => {
    getHotelDetails();
  }, []);

  // Submit new order to server
  const onSubmitOrder = (orderedArray) => {
    if (!selectedOfficeId) return;

    dispatch(updateHotelOrder({ officeId: selectedOfficeId, orderedArray }))
      .unwrap()
      .then(() => {
        setShowOrderModal(false);
        getHotelDetails();
      })
      .catch((err) => {
        console.error("Failed to update order", err);
      });
  };

  if (isLoading) {
    return <Loader />;
  }

  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <>
      {!showOrderModal && (
        <>
          {data && data.length > 0 ? (
            <table>
              <thead>
                <tr className="table-header">
                  <th>{RechargeStringLabels.hotelName}</th>
                  <th className="description-hotel">
                    {RechargeStringLabels.description}
                  </th>
                  <th>{RechargeStringLabels.location}</th>
                  <th>{RechargeStringLabels.time}</th>
                  <th className="address">{RechargeStringLabels.address}</th>
                  <th>{RechargeStringLabels.photo}</th>
                  {isVisitCompleted ? null : <th> </th>}
                </tr>
              </thead>
              {data.map((dataItem) => {
                return <HotelListTableBody dataItem={dataItem} key={dataItem._id} />;
              })}
            </table>
          ) : (
            <img src={noRecharge} alt="No Possibilities" className="no-img" />
          )}
        </>
      )}

      <ReorderModal
        show={showOrderModal}
        onClose={() => setShowOrderModal(false)}
        onSubmit={onSubmitOrder}
        data={data}
        title="Drag to reorder hotel items"
      />
    </>
  );
}

export default HotelListTable;